import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import { Survey } from '../../../api/services/surveys/types.ts'
import { SurveyTemplates } from '../../../api/services/user_assignment_codes/types.ts'
import {
  setSurveysTableActions,
  setSurveysTableColumns
} from '../../../utils/assignmentCodes/surveysTableSettings.tsx'
import Table from '../../common/Table/Table.tsx'

const SurveyTable = ({
  mainCodeId,
  codeAssignmentID,
  codeAssignment,
  surveyTemplates,
  surveys
}: {
  mainCodeId: number
  codeAssignmentID: number
  codeAssignment: string
  surveyTemplates: SurveyTemplates[]
  surveys: Survey[] | null
}) => {
  const navigate = useNavigate()
  const [checkedID, setCheckedID] = React.useState<number[]>([])

  const toggleNumber = (value: number | null) => {
    if (value === null) return

    setCheckedID((prev) => {
      return prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    })
  }

  const columns = useMemo(
    () => setSurveysTableColumns(codeAssignment, surveyTemplates, toggleNumber),
    []
  )

  const actions = useMemo(
    () =>
      setSurveysTableActions(
        navigate,
        codeAssignmentID,
        codeAssignment,
        mainCodeId,
        checkedID
      ),
    [checkedID]
  )

  return (
    <div className="mb-6 border-t-4 border-gray-200 pt-1 dark:border-gray-700">
      {surveys && <Table columns={columns} data={surveys} actions={actions} />}
    </div>
  )
}

export default React.memo(SurveyTable)
